<ng-template #positionDate>
  <div class="flex flex-col flex-wrap md:flex-row md:gap-3">
    <div class="flex flex-row gap-8 items-center">
      <tandem-form-input
        class="w-full lg:max-w-xs"
        [form]="dateRangeForm"
        [controlName]="'startDate'"
        [inputType]="'date'"
        [inputId]="'startDate'"
        [label]="'Start Date'"
        [placeholder]="'Start Date'"></tandem-form-input>
      <tandem-form-input
        class="w-full lg:max-w-xs"
        [form]="dateRangeForm"
        [controlName]="'endDate'"
        [inputType]="'date'"
        [inputId]="'endDate'"
        [label]="'End Date'"
        [placeholder]="'End Date'"></tandem-form-input>
        <input type="file" id="hiddenFileInput" (change)="onFileSelected($event)" hidden>
        <tandem-button class="whitespace-nowrap max-sm:hidden" color="primary" theme="outline" [onClick]="triggerFileInput.bind(this)">Import Transactions</tandem-button>
    </div>
  </div>
</ng-template>
<div class="relative w-full flex flex-row justify-center items-start py-10 md:py-20 gap-x-20">
  <div class="w-1/5 max-sm:hidden mt-40 relative">
    <tandem-card *ngIf="activeSection" class="max-sm:hidden mt-40 fixed top-1/4 w-60">
      <div class="space-y-4">
        <ng-container *ngIf="currentPageNumber < cashFlow.revenueSections.length">
          <p class="">{{getTotalText()}}</p>
        </ng-container>
        <ng-container *ngIf="currentPageNumber == cashFlow.revenueSections.length">
          <p class="">{{getTotalText()}}</p>
        </ng-container>
        <ng-container *ngIf="currentPageNumber > cashFlow.revenueSections.length">
          <p class="">{{getTotalText()}}</p>
        </ng-container>
      </div>
    </tandem-card>
  </div>

  <ng-container #section *ngIf="activeSection">
    <div class="flex w-full sm:w-4/5">
      <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-6xl">
        <div class="w-full max-sm:hidden">
          <div class="flex flex-row items-center">
            <div class="flex flex-col gap-y-3 w-full">
              <h1 class="text-4xl">{{activeSection ? activeSection.name : 'Summary'}}</h1>
              <h2 class="text-2xl">{{ activeSection.description || '' }}</h2>
            </div>
            <div class="flex flex-col gap-y-3 items-end">
              <h1 class="text-xl text-primary whitespace-nowrap">{{getPageLabel()}}</h1>
              <div class="flex flex-row gap-4 max-sm:hidden">
                <tandem-button  [onClick]="setPage.bind(this, currentPageNumber - 1)" color="white">Back</tandem-button>
                <tandem-button theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)" color="primary" [disabled]="dateRangeForm.invalid">Next</tandem-button>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full sm:hidden">
          <div class="flex flex-col gap-y-3">
            <h1 class="text-2xl text-primary">{{getPageLabel()}}</h1>
            <h2 class="text-xl">{{ activeSection.description || '' }}</h2>
          </div>
        </div>
        <ng-container *ngIf="uncategorizedRevenues.length > 0 || uncategorizedExpenses.length > 0" theme="primary-faded">
          <ng-container *ngIf="this.currentPageNumber <= this.cashFlow.revenueSections.length - 1">
            <tandem-new-table class="w-full"
                              convertText="Convert to Expense"
                              [tableConfiguration]="uncategorizedRevenueConfig"
                              [data]="uncategorizedRevenues"
                              (selectedActionPerformed)="handleActionFromUncategorized('revenue', $event)"
                              [moveOptions]="revenueMoveOptions"></tandem-new-table>
          </ng-container>
          <ng-container *ngIf="this.currentPageNumber > this.cashFlow.revenueSections.length - 1">
            <tandem-new-table class="w-full"
                              convertText="Convert to Revenue"
                              [tableConfiguration]="uncategorizedExpenseConfig"
              [data]="uncategorizedExpenses"
              (selectedActionPerformed)="handleActionFromUncategorized('expense', $event)"
              [moveOptions]="expenseMoveOptions"></tandem-new-table>
          </ng-container>
        </ng-container>
        <tandem-statement-item-table class="w-full" *ngFor="let cat of activeSection.categories" [statementItemCategory]="cat" [mode]="mode" (changesMade)="recalculateTotals()" [displayDate]="true" [displayMoveOption]="true" (itemMoved)="moveToUncategorized($event, cat)"></tandem-statement-item-table>
        <div class="w-full">
          <div class="flex flex-col gap-y-3 sm:flex-row justify-between items-center">
            <span class="text-2xl font-semibold sm:order-2">{{getTotalText()}}</span>
            <tandem-button class="sm:order-3 w-full sm:w-fit" theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)" [disabled]="dateRangeForm.invalid">Next</tandem-button>
            <tandem-button *ngIf="currentPageNumber === 0" class="sm:order-1 w-full sm:w-fit" color="white" [onClick]="onSubmit.bind(this)" [disabled]="dateRangeForm.invalid">Save and Exit</tandem-button>
            <tandem-button *ngIf="currentPageNumber !== 0" class="sm:order-1 w-full sm:w-fit" color="white" [onClick]="setPage.bind(this, currentPageNumber - 1)">Back</tandem-button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container #summary *ngIf="!activeSection">
    <div class="flex flex-col w-full">
      <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-6xl mb-8 sm:mb-20">
        <div class="w-full max-sm:hidden">
          <div class="flex flex-row items-center">
            <div class="flex flex-col gap-y-3 w-full">
              <h1 class="text-4xl">Summary</h1>
              <h2 class="text-2xl">Let's see an overview of your {{getTrackingToolName('single')}}</h2>
            </div>
            <div class="flex flex-col gap-y-3 items-end">
              <h1 class="text-xl text-primary whitespace-nowrap">5 of 5: Summary</h1>
            </div>
          </div>
        </div>
        <div class="w-full sm:hidden">
          <div class="flex flex-col gap-y-3">
            <h1 class="text-2xl text-primary">5 of 5: Summary</h1>
            <h2 class="text-xl">Let's see an overview of your {{getTrackingToolName('single')}}</h2>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-7xl">
        <div class="flex flex-col md:flex-row w-full gap-5 justify-between">
          <div class="flex flex-col justify-between h-full">
            <div class="flex flex-col gap-8">
              <div class="flex flex-col gap-y-3">
                <h2 class="text-2xl font-bold">Revenue</h2>
                <h5 class="text-lg">Total Revenue:  {{cashFlow.totalRevenue | currency}}</h5>
              </div>
              <div class="flex flex-col gap-y-3">
                <h2 class="text-2xl font-bold">Expenses</h2>
                <h5 class="text-lg">Total Expenses:  {{cashFlow.totalExpenses | currency}}</h5>
                <h5 class="text-lg" *ngFor="let section of cashFlow.expenseSections; let i = index">{{getSummaryText('expense', section, i)}}</h5>
              </div>
            </div>
            <div class="flex flex-row justify-center gap-4 mt-8 max-md:hidden">
              <tandem-button color="white" [onClick]="setPage.bind(this, currentPageNumber - 1)">Back</tandem-button>
              <tandem-button color="primary" [onClick]="onSubmit.bind(this)" [disabled]="dateRangeForm.invalid">Submit</tandem-button>
            </div>
          </div>
          <tandem-cash-flow-graph class="w-full" style="height: 60vh" [cashFlow]="cashFlow"></tandem-cash-flow-graph>
          <div class="flex flex-col justify-center gap-4 md:hidden w-full">
            <tandem-button class="w-full" color="primary" [onClick]="onSubmit.bind(this)" [disabled]="dateRangeForm.invalid">Submit</tandem-button>
            <tandem-button class="w-full" color="white" [onClick]="setPage.bind(this, currentPageNumber - 1)">Back</tandem-button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
